import Highcharts from 'highcharts';

export function showNoData(chartId) {
  // Create an empty chart
  const emptyChart = Highcharts.chart(chartId, {
    title: {
      text: ''
    }
  });

  if (emptyChart && typeof emptyChart.showNoData === 'function') {
      emptyChart.showNoData();
  }
}

export function buildChartColors(data, dataPropertyName, valuePropertyName = 'projectedValue') {
  // Build color array - sort non-special entries by value, assign colors in order
  const defaultColors = ['#99D17B', '#337357', '#00A6A6', '#7AE0F9', '#2B4570', '#EFCA08'];
  const colors = new Array(data.length);
  
  // Get indices of non-special entries sorted by value (highest first)
  // Special entries: 'unspecified' and 'medicaid total'
  const nonSpecialIndices = data
    .map((item, index) => ({ 
      index, 
      value: item[valuePropertyName], 
      isSpecial: item[dataPropertyName]?.toLowerCase() === 'unspecified' || 
                 item[dataPropertyName]?.toLowerCase() === 'medicaid total'
    }))
    .filter(item => !item.isSpecial)
    .sort((a, b) => b.value - a.value)
    .map(item => item.index);
  
  // Assign colors: unspecified = gray, medicaid total = yellow, others get colors by value rank
  data.forEach((d, index) => {
    const dataValue = d[dataPropertyName]?.toLowerCase();
    if (dataValue === 'unspecified') {
      colors[index] = '#C7C3C3';
    } else if (dataValue === 'medicaid total') {
      colors[index] = '#EFCA08';
    } else {
      const colorIndex = nonSpecialIndices.indexOf(index);
      colors[index] = defaultColors[colorIndex % defaultColors.length];
    }
  });
  
  return colors;
}

// Shared helpers for label/group sorting

// Derive a numeric ordering from age group label (e.g., "19-49" -> 19, "75+" -> 75)
export function getAgeGroupOrderValue(label) {
  if (!label || typeof label !== 'string') return Number.POSITIVE_INFINITY;
  const plusMatch = label.match(/(\d+)\s*\+/);
  if (plusMatch) return parseInt(plusMatch[1]);
  const rangeMatch = label.match(/(\d+)\s*[-–]\s*(\d+)/);
  if (rangeMatch) return parseInt(rangeMatch[1]);
  const anyNum = label.match(/(\d+)/);
  if (anyNum) return parseInt(anyNum[1]);
  return Number.POSITIVE_INFINITY;
}

// Sort grouped data array by groupKey (alphabetical, except age groups by numeric order)
export function sortGroupedData(groups, groupKey) {
  const copy = [...groups];
  if (groupKey && groupKey.toLowerCase().includes('age')) {
    copy.sort((a, b) => getAgeGroupOrderValue(a[groupKey]) - getAgeGroupOrderValue(b[groupKey]));
  } else {
    copy.sort((a, b) => String(a[groupKey]).localeCompare(String(b[groupKey]), undefined, { sensitivity: 'base' }));
  }
  return copy;
}

// Sort flat items (for pie charts), using labelKey
export function sortCategoryItems(items, labelKey) {
  const copy = [...items];
  if (labelKey && labelKey.toLowerCase().includes('age')) {
    copy.sort((a, b) => getAgeGroupOrderValue(a[labelKey]) - getAgeGroupOrderValue(b[labelKey]));
  } else {
    copy.sort((a, b) => String(a[labelKey]).localeCompare(String(b[labelKey]), undefined, { sensitivity: 'base' }));
  }
  return copy;
}